
import { connect } from 'react-redux';
import queryString from 'query-string';

import {
    clear,
    changeView,
    getInfo,
    getLegend,
    initProject,
    setLayerVisibility
} from '../actions/Map';
import MapPage from '../components/MapPage';

function mapDispatchToProps() {
    return {
        clear,
        changeView,
        getInfo,
        getLegend,
        initProject,
        setLayerVisibility
    };
}

function mapStateToProps(state, ownProps) {
    return {
        map: state.map,
        queryParams: queryString.parse(ownProps.location.search)
    };
}

export default connect(mapStateToProps, mapDispatchToProps())(MapPage);
